/*************************************************/
/* HEADER                                        */
/*************************************************/
export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--lvl-2';
    const submenuSelector = '.menu-nav--lvl-2';
    const activeClass = "active";
    const activeParentClass = "active-parent"; 
    let activeSubMenu = null;
    let activeParentMenuItem = null;
    const header = document.querySelector(".header");

    if (!header) return; // Exit early if header is not found

    const init = () => {
        document.addEventListener('click', (event) => {
            handleMenuInteraction(event);
        });
        
        document.addEventListener('keydown', (event) => {
            // Only trigger on 'Enter' key
            if (event.key === 'Enter' || event.keyCode === 13) {
                handleMenuInteraction(event);
            }
        });
        
        function handleMenuInteraction(event) {
            const menuItem = event.target.closest(parentMenuItemSelector);
            const clickedSubMenu = event.target.closest(submenuSelector);
        
            // 1. Clicking outside the menu should close the active submenu
            if (!menuItem && !clickedSubMenu && activeSubMenu) {
                closeSubMenu();
                return;
            }
        
            // 2. Clicking inside an already open submenu should not close it
            if (clickedSubMenu && clickedSubMenu === activeSubMenu) {
                return;
            }
        
            // 3. Clicking on a menu item should toggle the submenu
            if (menuItem) {
                const subMenu = menuItem.querySelector(submenuSelector);
                if (subMenu) {
                    toggleSubMenu(subMenu, menuItem);
                }
            }
        }
        
    };

    const toggleSubMenu = (subMenu, parentMenuItem) => {
        if (!subMenu) return;

        if (subMenu === activeSubMenu) {
            closeSubMenu();
        } else {
            openSubMenu(subMenu, parentMenuItem);
        }
    };

    const openSubMenu = (subMenu, parentMenuItem) => {
        closeSubMenu(); // Close any existing submenu first

        subMenu.setAttribute('aria-hidden', 'false');
        subMenu.classList.add(activeClass);
        activeSubMenu = subMenu;

        // Highlight the clicked parent menu item
        parentMenuItem.classList.add(activeParentClass);
        activeParentMenuItem = parentMenuItem;

        if (subMenu.classList.contains("menu-nav__mega")) {
            header.classList.add(activeClass);
        }
    };

    const closeSubMenu = () => {
        if (!activeSubMenu) return;

        activeSubMenu.setAttribute('aria-hidden', 'true');
        activeSubMenu.classList.remove(activeClass);

        // Remove highlight from previous parent menu item
        if (activeParentMenuItem) {
            activeParentMenuItem.classList.remove(activeParentClass);
            activeParentMenuItem = null;
        }

        if (activeSubMenu.classList.contains("menu-nav__mega")) {
            header.classList.remove(activeClass);
        }

        activeSubMenu = null;
    };

    init();
}
